import React from "react";

const CustomIcon = ({ type, className }) => {
  return React.createElement(type, { className: className });
};

export default CustomIcon;
